var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      staticClass: "link",
      attrs: { target: "_blank", disabled: _vm.isDisabled },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
        mouseenter: function ($event) {
          return _vm.onHover()
        },
        mouseup: function ($event) {
          return _vm.fetchUrl()
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }